import {Component, OnInit, OnDestroy, ViewChild} from '@angular/core';
import {EnvService} from "../../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../../services/auth.service";
import {MatLegacyTableDataSource as MatTableDataSource} from "@angular/material/legacy-table";
import {MatLegacyPaginator as MatPaginator} from "@angular/material/legacy-paginator";
import {SmscManagerFilter} from "./smscManager.filter";
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'micro-smscManagers',
  templateUrl: './smscManagers.component.html'
})
export class SmscManagersComponent implements OnInit, OnDestroy  {

  dataSource:MatTableDataSource<any> = new MatTableDataSource<any>();
  filter:SmscManagerFilter = new SmscManagerFilter();
  activeStats:any;
  statsTimer:any;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  constructor(private auth:AuthService,
              private env:EnvService,
              private http:HttpClient) {
    this.filter.anyChange.pipe(debounceTime(500)).subscribe(change => {
      this.reload();
    });
  }

  ngOnInit() {
    this.reload();
    this.getSmscManagerStats();
    this.statsTimer = setInterval(()=> {
      this.getSmscManagerStats();
    }, 15000);
  }

  ngOnDestroy() {
    if (this.statsTimer)
      clearInterval(this.statsTimer);
  }

  reload() {
    let params:HttpParams = this.filter.getParams()
        .set("page", '' + (this.paginator.pageIndex || 0))
        .set("size", '' + (this.paginator.pageSize || 20))
      ;

    this.http.get(`${this.env.e.url}/smsc/smscManagers`, {params: params}).subscribe(
      data => {
        let page = data as any;
        this.dataSource.data = page.content;
        this.paginator.pageIndex = page.number;
        this.paginator.pageSize = page.size;
        this.paginator.length = page.totalElements;
      }
    );
  }

  getSmscManagerStats() {
    this.http.get(`${this.env.e.url}/smsc/smscManagers/active`).subscribe(
      data => {
        this.activeStats = data;
        var x = Object.keys(this.activeStats);
      }
    );
  }

  getKeys(obj: any):any {
    let ka = Object.keys(obj);
    return ka?.length > 0 ? ka : undefined;
  }
}
